import { DynamicTool } from 'langchain/tools';

const OPEN_API_KEY =
  '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';

export const speechToText = (blobUrl: string) => {
  return new DynamicTool({
    name: 'transcribe_audio',
    description: 'Transcribes audio blobs using Whisper API',
    func: async () => {
      const url = await fetch(blobUrl);
      const audioBlob = await url.blob();

      const audioFile = new File([audioBlob], 'audio.webm', {
        type: 'audio/webm',
      });

      const formData = new FormData();
      formData.append('file', audioFile, 'audio.webm');
      formData.append('model', 'whisper-1');

      const response = await fetch(
        'https://api.openai.com/v1/audio/transcriptions',
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${OPEN_API_KEY}`,
          },
          body: formData,
        },
      );

      const result = await response.json();
      console.log('Transcription result:', result);
      return result.text;
    },
  });
};
